import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MailState } from './mail.reducer';

const selectState = createFeatureSelector<MailState>('mail');

// Selector to remove a member from mailMembers.members by index
export const selectMailMembersWithoutIndex = createSelector(
  selectState,
  (state: MailState, props: { indexToRemove: number }) => {
    if (state.mailMembers && state.mailMembers.members) {
      // Clone the members array and remove the element at the specified index
      const membersWithoutIndex = [...state.mailMembers.members];
      membersWithoutIndex.splice(props.indexToRemove, 1);
      return { ...state.mailMembers, members: membersWithoutIndex };
    }
    return state.mailMembers;
  }
);

// Existing selectors
export const selectMailMemberTemplates = createSelector(selectState, (state: MailState) => state.mailMembers);
export const selectMailTemplate = createSelector(selectState, (state: MailState) => state.mailTemplate);
export const selectSendMail = createSelector(selectState, (state: MailState) => state.isSendMail);
export const selectSaveMail = createSelector(selectState, (state: MailState) => state.mailMembers);
export const selectPreviewMail = createSelector(selectState, (state: MailState) => state.previewMail);
export const selectCommunicationLogs = createSelector(selectState, (state: MailState) => state.communicationLogs);
export const selectCommunicationError = createSelector(selectState, (state: MailState) => state.communicationsErrorResponse);
export const selectSaveReplyToEmailAddress = createSelector(selectState, (state: MailState) => state.isChangeReplyToEmailAddress);
export const selectEmailSaveSuccess = createSelector(selectState,(state: MailState) => state.emailSaveSuccess);
export const selectEmailSaveError = createSelector(selectState,(state: MailState) => state.emailSaveError);



export const selectSentMailLogs = createSelector(
  selectState,
  (state: MailState) => state.sentMailLogs
);

export const selectSentMailLogLoading = createSelector(
  selectState,
  (state: MailState) => state.loading
);

export const selectSentMailLogError = createSelector(
  selectState,
  (state: MailState) => state.error
);
